const HistoryRow = (props) => {
    const imgStyle = {
        width: 34,
        height: 34,
        borderRadius: '50%'
    },
    dateStyle = {
        textAlign: 'right'
    },
    imgCellStyle = {
        width: 40
    },
    boldText = {
        fontWeight: 'bold'
    }
    const history = props?.history
    return (
        <tr>
            <td style={imgCellStyle}>
                <img alt={history?.admin?.name} src={history?.admin?.logo} style={imgStyle}/>
            </td>
            <td>
                <span style={boldText}> {history?.admin?.name} </span>
                {history?.action} {history?.entity}
                <span style={boldText}> "{history?.entity_value}" </span>
            </td>
            <td style={dateStyle}> {history?.created} </td>
        </tr>
    )
}

export default HistoryRow